import { FormLabel } from '@mui/material';
import React from 'react';

interface IAccordionSummaryProps {
  children: React.ReactNode;
  required?: boolean;
}

export function AccordionSummary(props: IAccordionSummaryProps) {
  const { children, required = false } = props;

  if (required) {
    return (
      <FormLabel component="span" required sx={{ color: 'inherit', font: 'inherit' }}>
        {children}
      </FormLabel>
    );
  }

  return <span>{children}</span>;
}
